export const HEADERS_JSON = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

export const HEADERS_COMMON = {
  Accept: 'application/json',
};

export const QUERY_KEYS = {
  REG_STEP: 'REG_STEP',
  CABINET_STATUS: 'CABINET_STATUS',
  CABINET_NOTIFICATIONS: 'CABINET_NOTIFICATIONS',
  USER_PROFILE: 'USER_PROFILE',
  LOGIN_SMS: 'LOGIN_SMS',
  PAYMENTS_HISTORY: 'PAYMENTS_HISTORY',
  AGREEMENT_HISTORY: 'AGREEMENT_HISTORY',
  LOAN_PURPOSE_LIST: 'LOAN_PURPOSE_LIST',
  AUTH_STATUS: 'AUTH_STATUS',
  LOAN_APPLICATION: 'LOAN_APPLICATION',
};

export const SHORT_STALE_TIME = 1000; // 3 sec
